import { connect } from 'react-redux';
import { change as changeForm, getFormValues } from 'redux-form';

import { CLIENT_ACCIDENT_INSURANCE_FORM } from 'src/constants/FormNames';
import selector from 'src/utils/Utils';

import { getSelectOptions } from 'src/reducers/selectOptions';
import { getList, getExtras } from 'src/reducers/common/listReducer';
import {
  REDUCER_NAME,
  getAccidentInsuranceFormValues,
  getDefaultRateForEmployee,
  getDefaultRateForEmployer
} from 'src/reducers/clients/insurance';

import AccidentInsuranceCreatingForm from '../components/AccidentInsuranceCreatingForm';

const fetchInsurance = (insurances, value) => insurances.find(item => item.value === value) || {};

const fetchPremiumInsurance = insurance =>
  (insurance.occupationalAccidentInsuranceSubtypes || []).find(item => item.subtypeType === 'insurance_premium') || {};

const mapStateToProps = state => ({
  settingStartDate: getFormValues(CLIENT_ACCIDENT_INSURANCE_FORM)(state).settingStartDate,
  insuranceTypes: getSelectOptions(state, 'accidentInsurances'),
  insurances: getList(REDUCER_NAME, state),
  premiumRateForEmployee: selector(getAccidentInsuranceFormValues(state), 'premiumRateForEmployee'),
  premiumRateForEmployer: selector(getAccidentInsuranceFormValues(state), 'premiumRateForEmployer'),
  selectedInsuranceType: selector(getAccidentInsuranceFormValues(state), 'insuranceType'),
  isFirstSet: selector(getExtras(REDUCER_NAME, state), 'isFirstSet'),
  isInput: selector(getAccidentInsuranceFormValues(state), 'isInput')
});

const mapDispatchToProps = dispatch => ({
  handleInsuranceTypeChange: (selectedType, settingStartDate, insurances) => {
    const insurance = fetchInsurance(insurances, selectedType);
    const premiumInsurance = fetchPremiumInsurance(insurance);
    dispatch(
      changeForm(
        CLIENT_ACCIDENT_INSURANCE_FORM,
        'premiumRateForEmployee',
        getDefaultRateForEmployee(settingStartDate, premiumInsurance)
      )
    );
    dispatch(
      changeForm(
        CLIENT_ACCIDENT_INSURANCE_FORM,
        'premiumRateForEmployer',
        getDefaultRateForEmployer(settingStartDate, premiumInsurance)
      )
    );
  },
  changeIsInput: value => {
    dispatch(changeForm(CLIENT_ACCIDENT_INSURANCE_FORM, 'isInput', value));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AccidentInsuranceCreatingForm);
